// extracted by mini-css-extract-plugin
module.exports = {"stickyItems":"infiniteList__stickyItems___dqJTf","outer":"infiniteList__outer___3Q32S"};